

export default function TransformData ( date)
{
    const slectedDta = new window.Date( date );
    const getfullYear = slectedDta.getFullYear();
    const getmonth =( slectedDta.getMonth()+1).toString().padStart(2,0);
    const getday = slectedDta.getDay().toString().padStart( 2, 0 );
    return `${getfullYear}-${getmonth}-${getday}`

}